<template>
  <form novalidate @submit.prevent="updatePassword">
    <b-form-group label="New password" label-for="inputTextNewPassword">
      <div class="field-with-toggle">
        <b-form-input
          id="inputTextNewPassword"
          v-model="form.new_password"
          :type="newPasswordVisible ? 'text' : 'password'"
          autocomplete="new-password"
          placeholder="Enter new password"
          :class="errors.new_password || $v.form.new_password.$error ? 'is-invalid' : ''"
        ></b-form-input>
        <button
          type="button"
          class="field-toggle"
          :aria-pressed="newPasswordVisible ? 'true' : 'false'"
          @click="newPasswordVisible = !newPasswordVisible"
        >{{ newPasswordVisible ? 'Hide' : 'Show' }}</button>
        <b-form-invalid-feedback v-if="errors.new_password">
          {{ errors.new_password }}
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="!$v.form.new_password.required">
          Can not be empty
        </b-form-invalid-feedback>
      </div>
    </b-form-group>

    <b-form-group label="Confirm new password" label-for="inputTextConfirmNewPassword">
      <div class="field-with-toggle">
        <b-form-input
          id="inputTextConfirmNewPassword"
          v-model="form.confirm_new_password"
          :type="confirmPasswordVisible ? 'text' : 'password'"
          autocomplete="new-password"
          placeholder="Repeat new password"
          :class="errors.confirm_new_password || $v.form.confirm_new_password.$error ? 'is-invalid' : ''"
        ></b-form-input>
        <button
          type="button"
          class="field-toggle"
          :aria-pressed="confirmPasswordVisible ? 'true' : 'false'"
          @click="confirmPasswordVisible = !confirmPasswordVisible"
        >{{ confirmPasswordVisible ? 'Hide' : 'Show' }}</button>
        <b-form-invalid-feedback v-if="errors.confirm_new_password">
          {{ errors.confirm_new_password }}
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="!$v.form.confirm_new_password.required">
          Can not be empty
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-else-if="!$v.form.confirm_new_password.sameAs">
          Passwords do not match
        </b-form-invalid-feedback>
      </div>
    </b-form-group>

    <button class="submit-btn" type="submit" :disabled="isSubmit">
      {{ isSubmit ? 'Updating…' : 'Update password' }}
    </button>

    <p v-if="formError" class="form-status" data-tone="error" role="status" aria-live="polite">
      {{ formError }}
    </p>
  </form>
</template>

<script>
import { required, sameAs } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import axios from 'axios';
import { bodyStatusError, requestErrorMessage } from '@/util/master/requestError';

const FALLBACK_ERROR = 'Failed to update password. Please try again later.';

export default {
  name: 'UpdatePasswordForm',
  mixins: [validationMixin],
  data() {
    return {
      errors: {},
      formError: '',
      form: {
        new_password: undefined,
        confirm_new_password: undefined,
      },
      isSubmit: false,
      newPasswordVisible: false,
      confirmPasswordVisible: false,
    };
  },
  validations: {
    form: {
      new_password: {
        required,
      },
      confirm_new_password: {
        required,
        sameAs: sameAs('new_password'),
      },
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'form.new_password': function () {
      this.$v.form.new_password.$touch();
    },
    // eslint-disable-next-line func-names
    'form.confirm_new_password': function () {
      this.$v.form.confirm_new_password.$touch();
    },
  },
  methods: {
    async updatePassword() {
      this.resetError();
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;

      this.isSubmit = true;
      try {
        const { emailtoken, token } = this.$route.params;
        const res = await axios.post('/api/account/reset_password/reset', {
          password: this.form.new_password,
          email: emailtoken,
          token,
        });
        // gagalnya dateng HTTP 200, jadi statusnya dibaca dari body
        const failed = bodyStatusError(res.data);
        if (failed) {
          this.fail(failed.message);
          return;
        }
        this.$emit('onSuccess');
      } catch (err) {
        this.fail(requestErrorMessage(err, FALLBACK_ERROR));
      } finally {
        this.isSubmit = false;
      }
    },
    fail(message) {
      this.formError = message;
      this.$emit('onFailure', message);
    },
    resetError() {
      this.errors = {};
      this.formError = '';
    },
  },
};
</script>
